(() => {
  const toggle = document.querySelector('.site-header__toggle');
  if (!toggle) return;

  toggle.addEventListener('click', () => {
    const isOpen = document.body.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains('menu-open')) {
      document.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  });
})();


// ============================================================
// MOBILE MENU
// ============================================================
(function () {
  const toggle = document.getElementById('MobileMenuToggle');
  const menu = document.getElementById('MobileMenu');
  const overlay = document.getElementById('MobileMenuOverlay');
  const closeBtn = document.getElementById('MobileMenuClose');

  function openMenu() {
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('menu-open');
    toggle && (toggle.setAttribute('aria-expanded', 'true'));
    menu && (menu.setAttribute('aria-hidden', 'false'));
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    toggle && (toggle.setAttribute('aria-expanded', 'false'));
    menu && (menu.setAttribute('aria-hidden', 'true'));
  }

  toggle && toggle.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', closeMenu);

  // Accordion sub-menus
  document.querySelectorAll('.mobile-menu__parent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      // Close all others
      document.querySelectorAll('.mobile-menu__parent').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        const sub = b.nextElementSibling;
        if (sub) sub.classList.remove('is-open');
      });
      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        const sub = this.nextElementSibling;
        if (sub) sub.classList.add('is-open');
      }
    });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();


/* ── Prestige grid fix: runs on load, overrides cached CSS ── */
(function() {
  function fixGrid() {
    var grid = document.querySelector('.category-tiles__grid');
    if (!grid) return;
    grid.style.setProperty('display', 'grid', 'important');
    grid.style.setProperty('grid-template-columns', 
      window.innerWidth >= 900 ? 'repeat(3,1fr)' : 'repeat(2,1fr)', 'important');
    grid.style.setProperty('gap', '12px', 'important');
    // Compact tile images on mobile
    if (window.innerWidth < 600) {
      document.querySelectorAll('.cat-tile__img-wrap').forEach(function(el) {
        el.style.setProperty('height', '120px', 'important');
      });
      document.querySelectorAll('.cat-tile__body').forEach(function(el) {
        el.style.setProperty('padding', '8px 10px 10px', 'important');
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGrid);
  } else {
    fixGrid();
  }
  window.addEventListener('resize', fixGrid);
})();
